export interface ContentSubscriptions {
  todaysEscapesSubscribed: boolean
  curatedCollectionSubscribed: boolean
  myJourneySubscribed: boolean
}

export const ASSUMED_CONTENT_SUBSCRIPTIONS: ContentSubscriptions = {
  todaysEscapesSubscribed: true,
  curatedCollectionSubscribed: true,
  myJourneySubscribed: true,
}

const ALL_CONTENT_SUBSCRIBED: Partial<App.SubscriptionPreferencesV2> = {
  todaysEscapesSubscribed: true,
  curatedCollectionSubscribed: true,
  myJourneySubscribed: true,
}

const ALL_CONTENT_UNSUBSCRIBED: Partial<App.SubscriptionPreferencesV2> = {
  todaysEscapesSubscribed: false,
  curatedCollectionSubscribed: false,
  myJourneySubscribed: false,
}

export interface ContentSubscriptionDecision {
  subscribeToTodaysEscapes?: boolean
  contentSubscriptions: ContentSubscriptions
}

export function getContentSubscriptionUpdate(decision: ContentSubscriptionDecision): Partial<App.SubscriptionPreferencesV2> {
  const { subscribeToTodaysEscapes, contentSubscriptions } = decision

  if (subscribeToTodaysEscapes === undefined) return {}
  if (!subscribeToTodaysEscapes) return ALL_CONTENT_UNSUBSCRIBED

  const receivesAnyContent = contentSubscriptions.todaysEscapesSubscribed ||
    contentSubscriptions.curatedCollectionSubscribed ||
    contentSubscriptions.myJourneySubscribed

  return receivesAnyContent ? {} : ALL_CONTENT_SUBSCRIBED
}
